import React from 'react';
import { useCatalog } from '../../catalog';
import { useImageLoad } from '../../utils/useImageLoad';
import '../../ui/cdn-img.css';
import { resolveEntityDisplayName, resolveEntityImageUrl, StatisticsEntityKind } from './statisticsEntity';
import './StatisticsEntityIcon.css';

type StatisticsEntityIconProps = {
  name: string;
  kind: StatisticsEntityKind;
  size?: 'md' | 'lg';
};

const StatisticsEntityIcon: React.FC<StatisticsEntityIconProps> = ({ name, kind, size = 'md' }) => {
  const catalog = useCatalog();
  const imageUrl = resolveEntityImageUrl(catalog, kind, name);
  const label = resolveEntityDisplayName(catalog, kind, name);
  const { ref, loaded, failed, onLoad, onError } = useImageLoad(imageUrl || undefined);
  const className = `stp-cell-icon stp-cell-icon--${kind} stp-cell-icon--${size}`;

  if (failed || !imageUrl) {
    return (
      <div className={`${className} stp-cell-icon--fallback`} title={label}>
        {label.slice(0, 2)}
      </div>
    );
  }

  return (
    <img
      ref={ref}
      src={imageUrl}
      alt={label}
      title={label}
      className={`${className} cdn-img${loaded ? ' cdn-img--loaded' : ''}`}
      loading="eager"
      decoding="async"
      onLoad={onLoad}
      onError={onError}
    />
  );
};

export default StatisticsEntityIcon;
